// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — zone-row.styled.classic.js, новая — zone-row.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './zone-row.styled.classic';
import * as cp from './zone-row.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const Count = isCp ? cp.Count : classic.Count;
